<p-select 
     [options]="options" 
     optionLabel="label" 
     optionValue="value" 
     [emptyMessage]="'No hay opciones disponibles'" 
     [placeholder]="placeholder" 
     [disabled]="disabled"
     (onChange)="onOptionSelect($event)" 
     (onBlur)="onTouched()" 
     [(ngModel)]="selectedValue" 
     (ngModelChange)="setValue($event)" 
     [ngClass]="[className, prefixClass]"
/>
